"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const ID_TOKEN = "";
var _default = exports.default = ID_TOKEN;